import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: "easeOut" }}
  >
    {children}
  </motion.div>
);

export default function SectionHeading({ eyebrow, title, accent, subtext, align = "center" }) {
  const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <Reveal className={`max-w-3xl mb-12 md:mb-16 ${alignCls}`}>
      <p className="text-xs sm:text-sm uppercase tracking-[0.25em] font-semibold text-[#FF5A1F] mb-3">
        {eyebrow}
      </p>
      <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl uppercase leading-none tracking-wide text-white">
        {title} {accent && <span className="text-[#FF5A1F]">{accent}</span>}
      </h2>
      {subtext && (
        <p className="mt-4 text-base sm:text-lg leading-relaxed text-[#D1D1D1]">{subtext}</p>
      )}
      <div
        className={`mt-6 h-1 w-20 bg-[#FF5A1F] rounded-full ${align === "center" ? "mx-auto" : ""}`}
      />
    </Reveal>
  );
}
